import { Injector, Injectable } from '@angular/core';
import { CarRegisterTealiumEvent } from 'marketing-tealiumhub';
import { Platform } from '../../shared/enums/platform.enum';
import { ConfigurationData } from '../config.service';
import { SessionService } from '../session.service';

@Injectable({
  providedIn: 'root'
})
export class AnalyticsService {

  private services: AnalyticsImplementation[] = [];
  private sessionService: SessionService;

  constructor(private injector: Injector) {
    const data: any = this.injector.get(AnalyticsImplementation);
    for (let index = 0; index < data.length; index++) {
      const element = data[index];
      this.services.push(element as AnalyticsImplementation);
    }

    this.sessionService = this.injector.get(SessionService);
  }

  public init(configData: ConfigurationData) {
    for (var i = 0; i < this.services.length; i++) {
      this.services[i].init(configData);
    }
  }

  public recordEvent(eventName: any, context: any, data: any) {
    data = this.formatDateProperties(data || {});
    for (var i = 0; i < this.services.length; i++) {
      this.services[i].recordEvent(eventName, context, data);
    }
  };

  public recordPageView(pageType: AnalyticsPageType, data: any) {
    data = this.formatDateProperties(data || {});
    for (var i = 0; i < this.services.length; i++) {
      console.log('Analytics Service - recordPageView - Class name: ', this.services[i]);
      console.log('Analytics Service - recordPageView - Has prop:', this.services[i].hasOwnProperty('tealium'));
      if (this.services[i].hasOwnProperty('tealium')) {
        const result = this.AppendCarRegisterTealiumEvent(pageType, this.sessionService, data);
        console.log('TealiumHub result: ', result);
      }
      else {
        this.services[i].recordPageView(pageType, data);
      }
    }
  };

  public trackPageView(pageType: AnalyticsPageType, data: any) {
    data = this.formatDateProperties(data || {});
    for (var i = 0; i < this.services.length; i++) {
      this.services[i].trackPageView(pageType, data);
    }
  };

  public trackFeatureUsage(context: any, data: any) {
    this.recordEvent("TrackFeatureUsage", context, data);
  }

  private formatDateProperties(data: any) {
    let objectKeys = Object.keys(data);
    for (var i = 0; i < objectKeys.length; i++) {
      if (data[objectKeys[i]] instanceof Date) {
        let date = data[objectKeys[i]];
        data[objectKeys[i]] = (date.getMonth() + 1) + "/" + date.getDate() + "/" + date.getFullYear();
      }
    }
    return data;
  }

  private AppendCarRegisterTealiumEvent(pageType: any, sessionService: SessionService, data: any) {

    const sessionData = sessionService.getSessionData();
    const platform = sessionData.getPlatform();
    let th_partner_id = sessionData.partnerId;
    if (platform === Platform.SOR) {
      th_partner_id += '-SOR';
    }

    const additionalData = {
      partner_id: th_partner_id,
      name_id: sessionData.nameId,
      member_id: sessionData.memberId,
      platform: platform
    }

    const nData = {};
    Object.assign(nData, data, additionalData);
    CarRegisterTealiumEvent(pageType, sessionService, nData);
  }
}


export enum AnalyticsPageType {
  Undefined = "Undefined",
  CarSearcResults = "CarSearcResults",
  CarReviewSelection = "CarReviewSelection",
  CarReservation = "CarReservation",
  CarBookingConfirmation = "CarBookingConfirmation",
  Checkout = "Checkout",
  CheckoutFailed = "CheckoutFailed",
  BookingCompletion = "BookingCompletion",
  BookingCompletionFailed = "BookingCompletionFailed",
  DestinationSearch = "DestinationSearch",
  DestinationSearchFailed = "DestinationSearchFailed",
  ProductDetails = "ProductDetails",
  ProductDetailsFailed = "ProductDetailsFailed"
}

export abstract class AnalyticsImplementation {
  abstract init(config: ConfigurationData): void;
  abstract recordEvent(eventName: any, context: any, data: any): void;
  abstract recordPageView(pageType: AnalyticsPageType, data: any): void;
  abstract trackPageView(pageType: AnalyticsPageType, data: any): void;
  abstract recordException(exception: Error): void;
}
